
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-28c993a7\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"@import '~@/assets/scss/_settings.scss';\\n\",\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RelatedPosts.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RelatedPosts.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-28c993a7\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RelatedPosts.vue"),
  /* scopeId */
  "data-v-28c993a7",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RelatedPosts.vue
// module id = 61
// module chunks = 0